import { render, staticRenderFns } from "./Prize_basket.vue?vue&type=template&id=7ba7c68b&scoped=true"
import script from "./Prize_basket.vue?vue&type=script&lang=js"
export * from "./Prize_basket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba7c68b",
  null
  
)

export default component.exports